import { Scroll } from '../_app/cuchillo/scroll/Scroll';
import ScrollItem__BlockDefault from './ScrollItem__BlockDefault';

class ScrollItem__CaseQuote extends ScrollItem__BlockDefault {
    constructor(__link, __index, __scroller) {
        super(__link, __index, __scroller);
    }
}

Scroll._registerClass('CaseQuote', ScrollItem__CaseQuote);

export default ScrollItem__CaseQuote;
